module.exports = __webpack_public_path__ + "statics/img/2-5.3b0b59d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/2-5.png
// module id = Tuf4
// module chunks = 1